module.exports = __webpack_public_path__ + "8b33c09559894233adf7604eb687e18e.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/default/variant-naming/images-more-on-naming/img4.png
// module id = 1307
// module chunks = 0